export const tickets = {
  en: {
    title: "Project Board",
    allTypes: "All Types",
    allStages: "All Stages",
    allPriority: "All Priority",
    allCompanies: "All Companies",
    allAssignees: "All Assignees",
    filterByType: "Filter by ticket type",
    filterByStage: "Filter by stage",
    filterByPriority: "Filter by priority",
    filterByCompany: "Filter by company",
    filterByAssignee: "Filter by assignee",
    clearFilters: "Clear all filters",
    tickets: "tickets",
    intake: "intake",
    tasks: "tasks",
    active: "active",
    ticketStats: "Ticket statistics",
    showStageGuide: "Show stage guide",
    ticketStages: "Ticket Stages",
    stageGuideDesc: "Drag tickets between columns to update stage.",
    newTicket: "New Ticket",
    new: "New",
    loading: "Loading tickets...",
    errorLoading: "Error loading tickets:",
    retry: "Retry",
    deleteTicket: "Delete Ticket",
    deleteConfirm: "Are you sure you want to delete this ticket? This action cannot be undone.",
    deleting: "Deleting...",
    boardError: "Board Error",
    boardErrorDesc: "Failed to render the project board. This might be due to corrupted ticket data.",
    // New ticket page
    newTicketTitle: "New Ticket",
    newTicketSubtitle: "Create a new intake request or task",
    intakeRequest: "Intake Request",
    task: "Task",
    requestDetails: "Request Details",
    requestDetailsDesc: "Additional information about this service request",
    companyNameLabel: "Company Name",
    urgencyLevel: "Urgency Level",
    flexible: "Flexible",
    standard: "Standard",
    expedited: "Expedited",
    urgent: "Urgent",
    taskOptions: "Task Options",
    taskOptionsDesc: "Configure task-specific settings",
    requiresClientApproval: "Requires Client Approval",
    requiresClientApprovalDesc: "Client must approve before marking complete",
    claudeCodeInstruction: "Claude Code Instruction",
    claudeCodeInstructionDesc: "Task can be executed by Claude Code agent",
    taskDetails: "Task Details",
    titleRequired: "Title *",
    titlePlaceholderIntake: "Brief description of your request",
    titlePlaceholderTask: "Task title",
    description: "Description",
    descriptionPlaceholder: "Provide more details... You can paste or drag images here.",
    customer: "Customer",
    selectCompany: "Select company",
    serviceType: "Service Type",
    selectService: "Select service",
    priority: "Priority",
    estimatedHours: "Estimated Hours",
    dueDate: "Due Date",
    startDate: "Start Date",
    endDate: "End Date",
    uploadingImages: "Uploading images...",
    createIntakeRequest: "Create Intake Request",
    createTask: "Create Task",
    // Ticket detail page
    backToTickets: "Back to Tickets",
    ticketNotFound: "Ticket not found",
    claudeInstruction: "Claude Instruction",
    clickToEditTitle: "Click to edit title",
    moveTo: "Move to...",
    moreActions: "More actions",
    noDescriptionProvided: "No description provided. Click Edit to add one.",
    enterDescription: "Enter a description...",
    deliverable: "Deliverable",
    noDeliverableProvided: "No deliverable content yet. Click Edit to add one.",
    enterDeliverable: "Enter deliverable content...",
    // Approval section
    approvalRequirements: "Approval Requirements",
    approverNotAssigned: "Approver not assigned",
    teamApprovalRequired: "Team approval required but no reviewer assigned.",
    clientApprovalRequired: "Client approval required but no contact assigned.",
    editTicketToAssign: "Edit ticket to assign",
    clientApproval: "Client Approval",
    teammateApproval: "Teammate Approval",
    approved: "Approved",
    rejected: "Rejected",
    pending: "Pending",
    notRequested: "Not Requested",
    requestApproval: "Request Approval",
    reRequestApproval: "Re-request Approval",
    yourApprovalRequested: "Your approval is requested:",
    reject: "Reject",
    approve: "Approve",
    approvalHistory: "Approval History",
    approval: "approval",
    teamApproved: "Team Approved",
    teamRejected: "Team Rejected",
    teamReviewPending: "Team Review Pending",
    requiresTeamReview: "Requires Team Review",
    clientApproved: "Client Approved",
    clientRejected: "Client Rejected",
    clientReviewPending: "Client Review Pending",
    requiresClientApprovalBadge: "Requires Client Approval",
    // Tabs
    checklist: "Checklist",
    comments: "Comments",
    // Sidebar
    details: "Details",
    submittedBy: "Submitted By",
    dueDateLabel: "Due date",
    actualEstimated: "Actual / Estimated",
    assignees: "Assignees",
    solariisAssignees: "Solariis Assignees",
    clientTeam: "Client Team",
    noAssigneesYet: "No assignees yet",
    addTeamMember: "Add team member",
    addAssignee: "Add assignee",
    addClientAssignee: "Add client contact",
    // Delete dialog
    deleteTicketQuestion: "Delete ticket?",
    deleteTicketDetailConfirm: "This will permanently delete {ticketNumber} and all associated data. This action cannot be undone.",
    // Timestamps
    created: "Created",
    updated: "Updated",
    submittedLabel: "Submitted",
    createdBy: "Created by",
    // TicketForm
    titleIsRequired: "Title is required",
    titleMaxLength: "Title must be 200 characters or less",
    mustBePositive: "Must be a positive number",
    editTicket: "Edit Ticket",
    createNewTicket: "Create New Ticket",
    editTicketDesc: "Update the ticket details below.",
    createTicketDesc: "Fill in the details to create a new ticket.",
    titleLabel: "Title",
    enhanceBtn: "Enhance",
    reEnhance: "Re-enhance",
    titlePlaceholderDefault: "e.g., Brand Redesign Project, Create homepage wireframes...",
    formDescriptionPlaceholder: "Describe the work to be done... You can paste or drag images here.",
    stage: "Stage",
    selectStage: "Select stage",
    selectPriority: "Select priority",
    estHours: "Est. Hours",
    additionalInfo: "Additional Info",
    optionalLabel: "(optional)",
    companyNameField: "Company Name",
    companyNamePlaceholder: "Acme Inc.",
    urgency: "Urgency",
    selectUrgency: "Select urgency",
    formApprovalRequirements: "Approval Requirements",
    requiresClientApprovalLabel: "Requires client approval",
    selectClientContact: "Select client contact",
    selectApprover: "Select approver...",
    selectCompanyFirst: "Select a company first to see available client contacts",
    noClientContacts: "No client contacts found for this company",
    formRequiresTeamReview: "Requires team review",
    selectTeamMember: "Select team member",
    noTeamMembers: "No team members found. Add team members in Settings → Team.",
    claudeCodeIntegration: "Claude Code Integration",
    claudeCodeInstLabel: "Claude Code instruction",
    claudeCodeInstDesc: "Mark for Claude Code execution. Enhanced description becomes the instruction.",
    checklistItems: "Checklist Items",
    addChecklistItem: "Add a checklist item...",
    selectTeamMemberApproval: "Please select a team member for approval",
    selectClientContactApproval: "Please select a client contact for approval",
    saveChanges: "Save Changes",
    createTicket: "Create Ticket",
    // ChecklistItemSheet
    checklistItem: "Checklist Item",
    editChecklistItemDesc: "Edit the details of this checklist item",
    taskDescriptionLabel: "Task Description",
    estimatedHoursLabel: "Estimated Hours",
    moduleTypeLabel: "Module Type",
    noneOption: "None",
    requiresApprovalLabel: "Requires approval before completion",
    statusLabel: "Status",
    completedStatus: "Completed",
    pendingStatus: "Pending",
    completedByLabel: "Completed by:",
    completedAtLabel: "Completed at:",
    createdLabel: "Created:",
    updatedLabel: "Updated:",
    deleteChecklistItem: "Delete Checklist Item",
    deleteChecklistItemConfirm: "Are you sure you want to delete this checklist item? This action cannot be undone.",
    savingChanges: "Saving...",
    checklistDescription: "Description",
    checklistDescriptionPlaceholder: "Additional notes or context...",
    // TicketComments
    writeReply: "Write a reply...",
    noCommentsYet: "No comments yet. Be the first to comment!",
    writeComment: "Write a comment...",
    // TicketChecklist
    addChecklistItemPlaceholder: "Add a checklist item...",
    clientActions: "Client Actions",
    clientActionLabel: "Client action — the client needs to complete this",
    // Sub-tickets
    subTicketsCompleted: "{completed} of {total} completed",
    noSubTasksYet: "No sub-tasks yet",
    breakIntoSmaller: "Break this ticket into smaller tasks",
    addSubTicket: "Add Sub-ticket",
    // Stage names (for TICKET_STAGES config)
    stageIntake: "Intake",
    stageBacklog: "Backlog",
    stageBlocked: "Blocked",
    stageTodo: "To-Do",
    stageInProgress: "In Progress",
    stagePendingApproval: "Pending Approval",
    stageDone: "Done",
    stageArchived: "Archived",
    // Stage descriptions
    stageIntakeDesc: "New request awaiting review",
    stageBacklogDesc: "Queued for work",
    stageBlockedDesc: "Waiting on dependencies",
    stageTodoDesc: "Ready to start",
    stageInProgressDesc: "Actively being worked",
    stagePendingApprovalDesc: "Awaiting approval",
    stageDoneDesc: "Completed",
    stageArchivedDesc: "Archived",
    // Type labels (for TICKET_TYPE_CONFIG)
    typeIntake: "Intake",
    typeTask: "Task",
    // Priority labels (for TICKET_PRIORITY_CONFIG)
    priorityLow: "Low",
    priorityMedium: "Medium",
    priorityHigh: "High",
    priorityUrgent: "Urgent",
    // Kanban board announcements & aria
    boardAriaLabel: "Project board with ticket columns",
    dragInstructions: "To pick up a ticket, press space or enter. While dragging, use arrow keys to move between columns. Press space or enter again to drop the ticket, or escape to cancel.",
    pickedUp: "picked up",
    isOverColumn: "is over column",
    movedTo: "moved to",
    dropped: "dropped",
    dragCancelled: "drag cancelled",
    addTicketTo: "Add ticket to",
    // Structured deliverable
    deliverableWhatYouReceive: "What You Receive",
    deliverableHowToUse: "How to Use This",
    deliverableNextSteps: "Next Steps",
    deliverableEstDays: "est. days",
    deliverableTierInfo: "Tier Details",
    // Published deliverable
    publishDeliverable: "Publish Deliverable",
    republishDeliverable: "Re-publish",
    publishedStatus: "Published",
    catalogOnlyStatus: "Catalog only",
    // Card actions
    archive: "Archive",
    teamReview: "Team Review",
    clientApprovalCard: "Client Approval",
    approvalPending: "Pending",
    approvalApproved: "Approved",
    approvalRejected: "Rejected",
    actionsForTicket: "Actions for ticket",
    ticketStageLabel: "Ticket stage",
    // Deliverable builder
    builderTitle: "Deliverable Builder",
    builderSummary: "Summary",
    builderSummaryPlaceholder: "Brief description of what this deliverable contains...",
    builderAddSection: "Add Section",
    builderAddRichText: "Rich Text",
    builderAddGallery: "File Gallery",
    builderAddTable: "Data Table",
    builderAddTyped: "Pipeline Section",
    builderAIGenerate: "AI Generate Draft",
    builderAIGenerating: "Generating...",
    builderAIEnhance: "Enhance with AI",
    builderAIEnhancing: "Enhancing...",
    builderSave: "Save Document",
    builderSaving: "Saving...",
    builderPreview: "Preview",
    builderEdit: "Edit",
    builderUnsaved: "Unsaved changes",
    builderEmpty: "No sections yet. Add a section or generate an AI draft.",
    builderDeleteSection: "Remove section",
    builderDeleteConfirm: "Remove this section?",
    builderMoveUp: "Move up",
    builderMoveDown: "Move down",
    builderSectionTitle: "Section title",
    builderLegacyNote: "This deliverable was created in an older format and has been converted for editing.",
    // Inline edit toasts & labels
    failedToAdvance: "Failed to change stage",
    failedToSave: "Failed to save",
    saved: "Saved",
    approver: "Approver",
    changeApprover: "Change",
    noApproverSet: "No approver set",
    assigneeAdded: "Assignee added",
    assigneeRemoved: "Assignee removed",
    approvalRequested: "Approval requested",
    stageChanged: "Stage changed",
    // Client Brief
    clientBrief: "Client Brief",
    clientBriefViewAll: "View all",
    clientBriefEmpty: "No key responses available yet.",
    clientBriefNoAnswers: "No brief answers yet",
    clientBriefComplete: "Complete the client brief",
    clientBriefViewFull: "View full brief",
    showBriefs: "Briefs",
  },
  es: {
    title: "Tablero de Proyectos",
    allTypes: "Todos los Tipos",
    allStages: "Todas las Etapas",
    allPriority: "Todas las Prioridades",
    allCompanies: "Todas las Empresas",
    allAssignees: "Todos los Asignados",
    filterByType: "Filtrar por tipo de ticket",
    filterByStage: "Filtrar por etapa",
    filterByPriority: "Filtrar por prioridad",
    filterByCompany: "Filtrar por empresa",
    filterByAssignee: "Filtrar por asignado",
    clearFilters: "Limpiar todos los filtros",
    tickets: "tickets",
    intake: "solicitudes",
    tasks: "tareas",
    active: "activos",
    ticketStats: "Estadísticas de tickets",
    showStageGuide: "Mostrar guía de etapas",
    ticketStages: "Etapas de Tickets",
    stageGuideDesc: "Arrastra tickets entre columnas para actualizar la etapa.",
    newTicket: "Nuevo Ticket",
    new: "Nuevo",
    loading: "Cargando tickets...",
    errorLoading: "Error al cargar tickets:",
    retry: "Reintentar",
    deleteTicket: "Eliminar Ticket",
    deleteConfirm: "¿Estás seguro de que deseas eliminar este ticket? Esta acción no se puede deshacer.",
    deleting: "Eliminando...",
    boardError: "Error del Tablero",
    boardErrorDesc: "Error al renderizar el tablero de proyectos. Esto puede deberse a datos de ticket corruptos.",
    // New ticket page
    newTicketTitle: "Nuevo Ticket",
    newTicketSubtitle: "Crea una nueva solicitud o tarea",
    intakeRequest: "Solicitud",
    task: "Tarea",
    requestDetails: "Detalles de la Solicitud",
    requestDetailsDesc: "Información adicional sobre esta solicitud de servicio",
    companyNameLabel: "Nombre de la Empresa",
    urgencyLevel: "Nivel de Urgencia",
    flexible: "Flexible",
    standard: "Estándar",
    expedited: "Expedito",
    urgent: "Urgente",
    taskOptions: "Opciones de Tarea",
    taskOptionsDesc: "Configura opciones específicas de la tarea",
    requiresClientApproval: "Requiere Aprobación del Cliente",
    requiresClientApprovalDesc: "El cliente debe aprobar antes de marcar como completada",
    claudeCodeInstruction: "Instrucción de Claude Code",
    claudeCodeInstructionDesc: "La tarea puede ser ejecutada por el agente Claude Code",
    taskDetails: "Detalles de la Tarea",
    titleRequired: "Título *",
    titlePlaceholderIntake: "Breve descripción de tu solicitud",
    titlePlaceholderTask: "Título de la tarea",
    description: "Descripción",
    descriptionPlaceholder: "Proporciona más detalles... Puedes pegar o arrastrar imágenes aquí.",
    customer: "Cliente",
    selectCompany: "Seleccionar empresa",
    serviceType: "Tipo de Servicio",
    selectService: "Seleccionar servicio",
    priority: "Prioridad",
    estimatedHours: "Horas Estimadas",
    dueDate: "Fecha de Vencimiento",
    startDate: "Fecha de Inicio",
    endDate: "Fecha de Fin",
    uploadingImages: "Subiendo imágenes...",
    createIntakeRequest: "Crear Solicitud",
    createTask: "Crear Tarea",
    // Ticket detail page
    backToTickets: "Volver a Tickets",
    ticketNotFound: "Ticket no encontrado",
    claudeInstruction: "Instrucción de Claude",
    clickToEditTitle: "Clic para editar título",
    moveTo: "Mover a...",
    moreActions: "Más acciones",
    noDescriptionProvided: "Sin descripción. Haz clic en Editar para agregar una.",
    enterDescription: "Ingresa una descripción...",
    deliverable: "Entregable",
    noDeliverableProvided: "Sin contenido de entregable. Haz clic en Editar para agregar uno.",
    enterDeliverable: "Ingresa el contenido del entregable...",
    // Approval section
    approvalRequirements: "Requisitos de Aprobación",
    approverNotAssigned: "Aprobador no asignado",
    teamApprovalRequired: "Se requiere aprobación del equipo pero no hay revisor asignado.",
    clientApprovalRequired: "Se requiere aprobación del cliente pero no hay contacto asignado.",
    editTicketToAssign: "Editar ticket para asignar",
    clientApproval: "Aprobación del Cliente",
    teammateApproval: "Aprobación del Compañero",
    approved: "Aprobado",
    rejected: "Rechazado",
    pending: "Pendiente",
    notRequested: "No Solicitado",
    requestApproval: "Solicitar Aprobación",
    reRequestApproval: "Re-solicitar Aprobación",
    yourApprovalRequested: "Se solicita tu aprobación:",
    reject: "Rechazar",
    approve: "Aprobar",
    approvalHistory: "Historial de Aprobación",
    approval: "aprobación",
    teamApproved: "Equipo Aprobó",
    teamRejected: "Equipo Rechazó",
    teamReviewPending: "Revisión de Equipo Pendiente",
    requiresTeamReview: "Requiere Revisión del Equipo",
    clientApproved: "Cliente Aprobó",
    clientRejected: "Cliente Rechazó",
    clientReviewPending: "Revisión de Cliente Pendiente",
    requiresClientApprovalBadge: "Requiere Aprobación del Cliente",
    // Tabs
    checklist: "Lista de Tareas",
    comments: "Comentarios",
    // Sidebar
    details: "Detalles",
    submittedBy: "Enviado Por",
    dueDateLabel: "Fecha de vencimiento",
    actualEstimated: "Real / Estimado",
    assignees: "Asignados",
    solariisAssignees: "Equipo Solariis",
    clientTeam: "Equipo del Cliente",
    noAssigneesYet: "Sin asignados aún",
    addTeamMember: "Agregar miembro del equipo",
    addClientAssignee: "Agregar contacto del cliente",
    addAssignee: "Agregar asignado",
    // Delete dialog
    deleteTicketQuestion: "¿Eliminar ticket?",
    deleteTicketDetailConfirm: "Esto eliminará permanentemente {ticketNumber} y todos los datos asociados. Esta acción no se puede deshacer.",
    // Timestamps
    created: "Creado",
    updated: "Actualizado",
    submittedLabel: "Enviado",
    createdBy: "Creado por",
    // TicketForm
    titleIsRequired: "El título es requerido",
    titleMaxLength: "El título debe tener 200 caracteres o menos",
    mustBePositive: "Debe ser un número positivo",
    editTicket: "Editar Ticket",
    createNewTicket: "Crear Nuevo Ticket",
    editTicketDesc: "Actualiza los detalles del ticket a continuación.",
    createTicketDesc: "Completa los detalles para crear un nuevo ticket.",
    titleLabel: "Título",
    enhanceBtn: "Mejorar",
    reEnhance: "Re-mejorar",
    titlePlaceholderDefault: "ej., Rediseño de Marca, Crear wireframes de página principal...",
    formDescriptionPlaceholder: "Describe el trabajo a realizar... Puedes pegar o arrastrar imágenes aquí.",
    stage: "Etapa",
    selectStage: "Seleccionar etapa",
    selectPriority: "Seleccionar prioridad",
    estHours: "Hrs Est.",
    additionalInfo: "Información Adicional",
    optionalLabel: "(opcional)",
    companyNameField: "Nombre de Empresa",
    companyNamePlaceholder: "Empresa S.A.",
    urgency: "Urgencia",
    selectUrgency: "Seleccionar urgencia",
    formApprovalRequirements: "Requisitos de Aprobación",
    requiresClientApprovalLabel: "Requiere aprobación del cliente",
    selectClientContact: "Seleccionar contacto del cliente",
    selectApprover: "Seleccionar aprobador...",
    selectCompanyFirst: "Selecciona una empresa primero para ver contactos disponibles",
    noClientContacts: "No se encontraron contactos del cliente para esta empresa",
    formRequiresTeamReview: "Requiere revisión del equipo",
    selectTeamMember: "Seleccionar miembro del equipo",
    noTeamMembers: "No se encontraron miembros del equipo. Agrega miembros en Configuración → Equipo.",
    claudeCodeIntegration: "Integración Claude Code",
    claudeCodeInstLabel: "Instrucción de Claude Code",
    claudeCodeInstDesc: "Marcar para ejecución de Claude Code. La descripción mejorada se convierte en la instrucción.",
    checklistItems: "Elementos de Lista",
    addChecklistItem: "Agregar un elemento a la lista...",
    selectTeamMemberApproval: "Por favor selecciona un miembro del equipo para aprobación",
    selectClientContactApproval: "Por favor selecciona un contacto del cliente para aprobación",
    saveChanges: "Guardar Cambios",
    createTicket: "Crear Ticket",
    // ChecklistItemSheet
    checklistItem: "Elemento de Lista",
    editChecklistItemDesc: "Edita los detalles de este elemento de lista",
    taskDescriptionLabel: "Descripción de la Tarea",
    estimatedHoursLabel: "Horas Estimadas",
    moduleTypeLabel: "Tipo de Módulo",
    noneOption: "Ninguno",
    requiresApprovalLabel: "Requiere aprobación antes de completar",
    statusLabel: "Estado",
    completedStatus: "Completado",
    pendingStatus: "Pendiente",
    completedByLabel: "Completado por:",
    completedAtLabel: "Completado el:",
    createdLabel: "Creado:",
    updatedLabel: "Actualizado:",
    deleteChecklistItem: "Eliminar Elemento de Lista",
    deleteChecklistItemConfirm: "¿Estás seguro de que deseas eliminar este elemento de lista? Esta acción no se puede deshacer.",
    savingChanges: "Guardando...",
    checklistDescription: "Descripcion",
    checklistDescriptionPlaceholder: "Notas adicionales o contexto...",
    // TicketComments
    writeReply: "Escribe una respuesta...",
    noCommentsYet: "Sin comentarios aún. ¡Sé el primero en comentar!",
    writeComment: "Escribe un comentario...",
    // TicketChecklist
    addChecklistItemPlaceholder: "Agregar un elemento a la lista...",
    clientActions: "Acciones del Cliente",
    clientActionLabel: "Accion del cliente — el cliente debe completar esto",
    // Sub-tickets
    subTicketsCompleted: "{completed} de {total} completadas",
    noSubTasksYet: "Sin sub-tareas aún",
    breakIntoSmaller: "Divide este ticket en tareas más pequeñas",
    addSubTicket: "Agregar Sub-ticket",
    // Stage names
    stageIntake: "Recepción",
    stageBacklog: "Pendientes",
    stageBlocked: "Bloqueado",
    stageTodo: "Por Hacer",
    stageInProgress: "En Progreso",
    stagePendingApproval: "Pendiente de Aprobación",
    stageDone: "Completado",
    stageArchived: "Archivado",
    // Stage descriptions
    stageIntakeDesc: "Nueva solicitud en espera de revisión",
    stageBacklogDesc: "En cola para trabajar",
    stageBlockedDesc: "Esperando dependencias",
    stageTodoDesc: "Listo para comenzar",
    stageInProgressDesc: "En trabajo activo",
    stagePendingApprovalDesc: "En espera de aprobación",
    stageDoneDesc: "Completado",
    stageArchivedDesc: "Archivado",
    // Type labels
    typeIntake: "Solicitud",
    typeTask: "Tarea",
    // Priority labels
    priorityLow: "Baja",
    priorityMedium: "Media",
    priorityHigh: "Alta",
    priorityUrgent: "Urgente",
    // Kanban board announcements & aria
    boardAriaLabel: "Tablero de proyecto con columnas de tickets",
    dragInstructions: "Para recoger un ticket, presiona espacio o enter. Mientras arrastras, usa las teclas de flecha para mover entre columnas. Presiona espacio o enter de nuevo para soltar, o escape para cancelar.",
    pickedUp: "recogido",
    isOverColumn: "está sobre la columna",
    movedTo: "movido a",
    dropped: "soltado",
    dragCancelled: "arrastre cancelado",
    addTicketTo: "Agregar ticket a",
    // Structured deliverable
    deliverableWhatYouReceive: "Que Recibes",
    deliverableHowToUse: "Como Usar Esto",
    deliverableNextSteps: "Proximos Pasos",
    deliverableEstDays: "dias est.",
    deliverableTierInfo: "Detalles del Tier",
    // Published deliverable
    publishDeliverable: "Publicar Entregable",
    republishDeliverable: "Re-publicar",
    publishedStatus: "Publicado",
    catalogOnlyStatus: "Solo catálogo",
    // Card actions
    archive: "Archivar",
    teamReview: "Revision de Equipo",
    clientApprovalCard: "Aprobacion del Cliente",
    approvalPending: "Pendiente",
    approvalApproved: "Aprobado",
    approvalRejected: "Rechazado",
    actionsForTicket: "Acciones para ticket",
    ticketStageLabel: "Etapa del ticket",
    // Deliverable builder
    builderTitle: "Constructor de Entregable",
    builderSummary: "Resumen",
    builderSummaryPlaceholder: "Breve descripcion de lo que contiene este entregable...",
    builderAddSection: "Agregar Seccion",
    builderAddRichText: "Texto Enriquecido",
    builderAddGallery: "Galeria de Archivos",
    builderAddTable: "Tabla de Datos",
    builderAddTyped: "Seccion de Pipeline",
    builderAIGenerate: "Generar Borrador IA",
    builderAIGenerating: "Generando...",
    builderAIEnhance: "Mejorar con IA",
    builderAIEnhancing: "Mejorando...",
    builderSave: "Guardar Documento",
    builderSaving: "Guardando...",
    builderPreview: "Vista Previa",
    builderEdit: "Editar",
    builderUnsaved: "Cambios sin guardar",
    builderEmpty: "Sin secciones. Agrega una seccion o genera un borrador con IA.",
    builderDeleteSection: "Eliminar seccion",
    builderDeleteConfirm: "Eliminar esta seccion?",
    builderMoveUp: "Mover arriba",
    builderMoveDown: "Mover abajo",
    builderSectionTitle: "Titulo de la seccion",
    builderLegacyNote: "Este entregable fue creado en un formato anterior y se convirtio para edicion.",
    // Inline edit toasts & labels
    failedToAdvance: "Error al cambiar etapa",
    failedToSave: "Error al guardar",
    saved: "Guardado",
    approver: "Aprobador",
    changeApprover: "Cambiar",
    noApproverSet: "Sin aprobador asignado",
    assigneeAdded: "Asignado agregado",
    assigneeRemoved: "Asignado eliminado",
    approvalRequested: "Aprobación solicitada",
    stageChanged: "Etapa cambiada",
    // Client Brief
    clientBrief: "Brief del Cliente",
    clientBriefViewAll: "Ver todo",
    clientBriefEmpty: "Aun no hay respuestas clave disponibles.",
    clientBriefNoAnswers: "Sin respuestas de brief aun",
    clientBriefComplete: "Completar el brief del cliente",
    clientBriefViewFull: "Ver brief completo",
    showBriefs: "Briefs",
  },
};
